module.exports = __webpack_public_path__ + "static/transportation-8b87666a8b5ef76becbea32bc611aa59.png";